export function sortNameAlphabeticalOrder(a: { name: string }, b: { name: string }): number {
  return a.name.localeCompare(b.name, 'pt-BR', {
    sensitivity: 'base',
  });
}
